<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-toolbar dense extended color="primary" dark style="padding-top:50px">
        <v-flex xs12 pa-5>
          <v-toolbar-title slot="extension" class="display-2">
            <v-icon x-large style="padding-bottom:10px">schedule</v-icon>
            Ingestion Schedules
          </v-toolbar-title>
          Manage job schedules and configuration assignments.
          <v-btn flat dark :to="{ name: 'ingestionDashboard' }" class="mt-2">
            <v-icon left>arrow_back</v-icon>Back to Dashboard
          </v-btn>
        </v-flex>
      </v-toolbar>
    </v-flex>
    <v-flex xs12 pa-3>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="openAdd">
            <v-icon left>add</v-icon>Add Schedule
          </v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="schedules" :loading="loading">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.Name }}</td>
            <td><code>{{ props.item.CronExpression }}</code></td>
            <td>{{ formatDate(props.item.CreatedAt) }}</td>
            <td class="text-xs-right">
              <v-btn small color="warning" depressed @click="openEdit(props.item)">Edit</v-btn>
              <v-btn small color="error" @click="confirmDelete(props.item)">Delete</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <!-- Add/Edit Dialog -->
    <v-dialog v-model="showDialog" max-width="500" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ isEdit ? 'Edit' : 'Add' }} Schedule</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-3">
          <v-form ref="form" lazy-validation>
            <v-text-field label="Name" v-model="form.Name" :rules="[rules.required]" required></v-text-field>
            <v-text-field label="Cron Expression" v-model="form.CronExpression"
              :rules="[rules.required]" required
              hint="5-field cron: minute hour day month weekday (e.g. 0 * * * *)"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" dark @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation -->
    <v-dialog v-model="showDeleteDialog" max-width="400">
      <v-card>
        <v-toolbar dark color="error"><v-toolbar-title>Confirm Delete</v-toolbar-title></v-toolbar>
        <v-card-text class="pt-3">Delete schedule "{{ deleteTarget ? deleteTarget.Name : '' }}"?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline @click="showDeleteDialog = false">Cancel</v-btn>
          <v-btn color="error" @click="doDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar :color="snackColor" :timeout="6000" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const ingestion = createNamespacedHelpers('ingestionManagement')

export default {
  data() {
    return {
      loading: false,
      showDialog: false,
      showDeleteDialog: false,
      isEdit: false,
      deleteTarget: null,
      form: this.emptyForm(),
      snackbar: false, snackColor: 'success', snackMessage: '',
      headers: [
        { text: 'Name', value: 'Name', align: 'left' },
        { text: 'Cron', value: 'CronExpression', align: 'left' },
        { text: 'Created', value: 'CreatedAt', align: 'left' },
        { text: 'Actions', value: null, align: 'right', sortable: false },
      ],
      rules: { required: v => !!v || 'Required' },
    }
  },
  computed: {
    ...ingestion.mapGetters(['schedules']),
  },
  methods: {
    ...ingestion.mapActions([
      'fetchSchedules', 'createSchedule', 'updateSchedule', 'deleteSchedule',
    ]),
    emptyForm() { return { Name: '', CronExpression: '', IsActive: true } },
    openAdd() { this.isEdit = false; this.form = this.emptyForm(); this.showDialog = true },
    openEdit(item) { this.isEdit = true; this.form = JSON.parse(JSON.stringify(item)); this.showDialog = true },
    closeDialog() { this.showDialog = false },
    save() {
      const data = JSON.parse(JSON.stringify(this.form))
      data.IsActive = true
      const onSuccess = () => {
        this.snackMessage = this.isEdit ? 'Schedule updated.' : 'Schedule created.'
        this.snackColor = 'success'; this.snackbar = true
        this.closeDialog(); this.loadData()
      }
      const onError = (err) => {
        this.snackMessage = err.response ? err.response.data : err.message
        this.snackColor = 'error'; this.snackbar = true
      }
      if (this.isEdit) {
        this.updateSchedule({ id: data.Id, data, successCb: onSuccess, failedCb: onError })
      } else {
        this.createSchedule({ data, successCb: onSuccess, failedCb: onError })
      }
    },
    confirmDelete(item) { this.deleteTarget = item; this.showDeleteDialog = true },
    doDelete() {
      this.deleteSchedule({ id: this.deleteTarget.Id,
        successCb: () => {
          this.snackMessage = 'Schedule deleted.'; this.snackColor = 'success'; this.snackbar = true
          this.showDeleteDialog = false
        },
        failedCb: (err) => {
          this.snackMessage = err.response ? err.response.data : err.message
          this.snackColor = 'error'; this.snackbar = true; this.showDeleteDialog = false
        },
      })
    },
    formatDate(d) { return d ? new Date(d).toLocaleString() : '' },
    loadData() {
      this.loading = true
      this.fetchSchedules().finally(() => { this.loading = false })
    },
  },
  mounted() { this.loadData() },
}
</script>
